import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import { ReactTabulator } from "react-tabulator";
import DownloadRequestAPI from "../api/DownloadRequestAPI";
import CaseAPI from "../api/CaseAPI";
import Loading from "../components/shared/Loading";

const $ = window.$;

function link(cell, formatterParams) {
  var url = cell.getValue();
  if (url)
    return "<a><i class='fa fa-download' aria-hidden='true'></i></a>";
  return "";
}
class MyDownloadsPage extends Component {
  ref = React.createRef();

  getColumns = () => {
    return [
      { title: this.props.t("myDownloads.columns.id"), field: "id" },
      { title: this.props.t("myDownloads.columns.workflow"), field: "params.workFlowName", headerHozAlign: "center", hozAlign: "center" },
      { title: this.props.t("myDownloads.columns.caseTable"), field: "params.caseStateTitle", headerHozAlign: "center", hozAlign: "center" },
      { title: this.props.t("myDownloads.columns.status"), field: "status", headerHozAlign: "center", hozAlign: "center" },
      { title: this.props.t("myDownloads.columns.created"), field: "auditInfo.lastModifiedDate", headerHozAlign: "center", hozAlign: "center" },
      { title: this.props.t("myDownloads.columns.download"), field: "url", formatter: link, headerHozAlign: "center", hozAlign: "center" }
    ];
  }

  state = {
    stateData: null,
    t: this.props.t,
    columns: this.getColumns(),
    pageInfo: {},
    currentPage: 1,
    lastPage: -1,
    paginationSize: 10,
    dataPerAPICall: 10,
    loading: false,
    data: [],
    options: {
      pagination: "remote",
      paginationSize: 10,
      placeholder: "<Fragment><section className='content-header'><h4 style='text-align:center'><i>" + this.props.t('caseManagement.noDownloadsMessage') + "</i></h4></section></Fragment>",
      ajaxURL: 'dummy_string_url',
      download: true,
      ajaxRequestFunc: (url, config, params) => {
        let _this = this;
        $('.tabulator-alert').hide();
        return new Promise(function (resolve, reject) {

          _this.loadFirstPageData(resolve);

        });
      },
      langs: {
        all: {
          pagination: {
            first: this.props.t("common.table.pagination.first"),
            first_title: this.props.t("common.table.pagination.first_title"),
            last: this.props.t("common.table.pagination.last"),
            last_title: this.props.t("common.table.pagination.last_title"),
            prev: this.props.t("common.table.pagination.prev"),
            prev_title: this.props.t("common.table.pagination.prev_title"),
            next: this.props.t("common.table.pagination.next"),
            next_title: this.props.t("common.table.pagination.next_title")
          }
        }
      }
    },
    isEdit: false
  };

  displayLoader = (visible) => {
    this.setState({ loading: visible });
  }

  initiatePageActionBtnEvents = () => {
    let _this = this;
    $('.tabulator-paginator button.tabulator-page').on('click', (e) => {
      let clickedPage = $(e.target).attr('data-page'), nextDest;

      if (clickedPage == 'last') {
        nextDest = Number(_this.state.lastPage);
      } else if (clickedPage == 'first') {
        nextDest = 1;
      } else if (clickedPage == 'next') {
        nextDest = Number(_this.state.currentPage) + 1;
      } else if (clickedPage == 'prev') {
        nextDest = Number(_this.state.currentPage) - 1;
      }
      let start = ((nextDest - 1) * _this.state.paginationSize), end = start + _this.state.dataPerAPICall;
      _this.loadNonFirstPageData(start, end, nextDest);
    })
  }

  initiatePageNumberBtnEvent = () => {
    let _this = this;
    $('.tabulator-pages button.tabulator-page').on('click', (e) => {
      let nextDest = $(e.target).attr('data-page'), start = ((nextDest - 1) * _this.state.paginationSize), end = start + _this.state.dataPerAPICall;
      _this.loadNonFirstPageData(start, end, nextDest);
    });
  }

  loadFirstPageData = (resolve) => {
    let _this = this;
    this.displayLoader(true);

    DownloadRequestAPI.all(0, this.state.dataPerAPICall).then(data => {
      _this.handleFirstPageData(data.content, data.totalElements, resolve);
      _this.displayLoader(false);


    });
  }

  displayLoader = (visible) => {
    this.setState({ loading: visible });
  }

  handleFirstPageData = (data, totalElements, resolve) => {
    for (let i = data.length; i < totalElements; i++) {
      data.push({});
    }

    let pageInfo = {}, size = this.state.paginationSize, page = 0;

    for (let i = 0; i < data.length; i += size) {
      let dataSlice = data.slice(i, i + size);
      ++page;
      pageInfo[page] = Object.keys(dataSlice[0]).length !== 0 ? dataSlice.length : 0;

    }

    this.setState({
      data: data,
      lastPage: page,
      pageInfo: pageInfo,
      currentPage: 1
    });

    if (resolve) {
      resolve(data);
      this.initiatePageActionBtnEvents();
      setTimeout(() => {
        this.initiatePageNumberBtnEvent();
      }, 1000);
    } else {
      this.ref.current.setData(data);
    }

    this.ref.current.columnManager.setColumns(this.state.columns);
    this.ref.current.columnManager.redraw(true)

  }

  loadNonFirstPageData = (start, end, nextDest) => {
    let _this = this;
    if (this.state.pageInfo[nextDest] !== 0) {
      this.setState({ currentPage: nextDest });
      return;
    }
    this.displayLoader(true);
    DownloadRequestAPI.all(nextDest - 1, this.state.dataPerAPICall).then(data => {
      _this.handleNonFirstPageData(data.content, start, nextDest);
      _this.displayLoader(false);
    });
  }

  handleNonFirstPageData = (data, start, nextDest) => {
    let init = start, existingData = this.state.data, index = 0;

    for (var i = init; i < init + data.length; i++) {
      existingData[i] = data[index];
      index++;
    }

    this.ref.current.replaceData(existingData)

    let pageInfo = this.state.pageInfo, size = this.state.paginationSize, page = nextDest;
    for (let i = 0; i < data.length; i += size) {
      let dataSlice = data.slice(i, i + size);
      pageInfo[page] = Object.keys(dataSlice[0]).length !== 0 ? dataSlice.length : 0;
      ++page;
    }
    this.setState({
      data: existingData,
      pageInfo: pageInfo,
      currentPage: nextDest
    });
    setTimeout(() => {
      this.initiatePageNumberBtnEvent();
    }, 1000);
  }


  componentDidUpdate(prevProps) {
    // Update columns when translation function changes (locale change)
    if (prevProps.t !== this.props.t) {
      const updatedColumns = this.getColumns();
      this.setState({ columns: updatedColumns, t: this.props.t });

      // Update the table columns if the reference exists
      if (this.ref && this.ref.current) {
        this.ref.current.columnManager.setColumns(updatedColumns);
        this.ref.current.columnManager.redraw(true);
      }
    }
  }

  refreshDownloadRequests = () =>{
    this.loadFirstPageData();
  }

  setRef(ref) {
    let _this = this;
    if (ref) {
      this.ref = ref;
      setTimeout(() => {
        ref.current.setLocale("all");
      }, 2000);

      this.ref.current.on("rowClick", function (e, row) {
        _this.displayLoader(true);
        let rowData = row.getData();
        CaseAPI.downloadExportedFile(rowData.id).then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = rowData.url;
          document.body.appendChild(a);
          a.click();
          _this.displayLoader(false);
        })
          .catch((e) => console.log(e));
      });
    }
  }

  render() {
    const { t } = this.props;
    const { columns, options, loading } = this.state;

    return (
      <Fragment>
        <div className="content-wrapper">
          <section className="content-header">
            <h1  style={{float:"left"}}>
              {t("mainMenu.myDownloads")} <small />
            </h1>
            <span style={{float:"right",marginBottom:"10px"}}>
            <button
                      type="button"
                      className="btn btn-primary"
                      style={{marginLeft:10, fontSize: "14px"}}
                      onClick={this.refreshDownloadRequests}
                      >{t("caseManagement.caseTable.refreshButton")}</button>
            </span>
          </section>

          <section className="content">
            <div className="row">
              <div className="col-xs-12">
                <div className="box">
                  <div className="box-body">

                    <ReactTabulator
                      onRef={ref => this.setRef(ref)}
                      columns={columns}
                      options={options}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        {loading && <Loading />}
      </Fragment>
    );
  }
}
export default withTranslation("common")(MyDownloadsPage);